import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 路由懒加载
const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue'),
        meta: { title: '登录' }
      },
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页', requiresAuth: true },
        children: [
          {
            path: '',
            name: 'HomeIndex',
            component: () => import('@/views/Home/Index.vue')
          },
          {
            path: 'prompt',
            name: 'Prompt',
            component: () => import('@/views/Prompt.vue'),
            meta: { title: '提示词管理', requiresAuth: true }
          },
          {
            path: 'creative',
            name: 'Creative',
            component: () => import('@/views/Creative.vue'),
            meta: { title: '创意中心', requiresAuth: true }
          },
          {
            path: 'admin',
            name: 'Admin',
            component: () => import('@/views/admin/Admin.vue'),
            meta: { title: '后台管理', requiresAuth: true },
            children: [
              {
                path: 'user-management',
                name: 'UserManagement',
                component: () => import('@/views/admin/UserManagement.vue'),
                meta: { title: '用户管理', requiresAuth: true }
              },
              {
                path: 'banned-word-management',
                name: 'BannedWordManagement',
                component: () => import('@/views/admin/BannedWordManagement.vue'),
                meta: { title: '违规词管理', requiresAuth: true }
              },
              {
                path: 'dictionary-management',
                name: 'DictionaryManagement',
                component: () => import('@/views/admin/DictionaryManagement.vue'),
                meta: { title: '字典管理', requiresAuth: true }
              },
              {
                path: 'model-management',
                name: 'ModelManagement',
                component: () => import('@/views/admin/ModelManagement.vue'),
                meta: { title: '模型管理', requiresAuth: true }
              },
              {
                path: 'model-editor/:id?',
                name: 'ModelEditor',
                component: () => import('@/views/components/ModelEditor.vue'),
                meta: { title: '模型编辑', requiresAuth: true }
              },
              {
                path: 'creative-management',
                name: 'CreativeManagement',
                component: () => import('@/views/admin/CreativeManagement.vue'),
                meta: { title: '创意管理', requiresAuth: true }
              },
              {
                path: 'prompt-management',
                name: 'PromptManagement',
                component: () => import('@/views/admin/PromptManagement.vue'),
                meta: { title: '提示词管理', requiresAuth: true }
              },
              {
                path: 'ai-default-prompt-management',
                name: 'AiDefaultPromptManagement',
                component: () => import('@/views/admin/AiDefaultPromptManagement.vue'),
                meta: { title: 'AI写作管理', requiresAuth: true }
              },
              {
                path: 'product-management',
                name: 'ProductManagement',
                component: () => import('@/views/admin/ProductManagement.vue'),
                meta: { title: '算力商品管理', requiresAuth: true }
              },
              {
                path: 'security',
                name: 'Security',
                component: () => import('@/views/admin/Security.vue'),
                meta: { title: '账户安全', requiresAuth: true }
              },
              {
                path: 'notification',
                name: 'Notification',
                component: () => import('@/views/admin/Notification.vue'),
                meta: { title: '消息通知', requiresAuth: true }
              },
              {
                path: 'global-config',
                name: 'GlobalConfig',
                component: () => import('@/views/admin/GlobalConfig.vue'),
                meta: { title: '全局配置', requiresAuth: true }
              }
            ]
          }
        ]
      },
      // 作品编辑器 - 独立全屏布局
      {
        path: '/work/:id',
        name: 'WorkEditor',
        component: () => import('@/views/WorkEditor/Index.vue'),
        meta: { title: '作品编辑', requiresAuth: true, fullscreen: true }
      },
      // 404 页面
      {
        path: '*',
        redirect: '/'
      }
    ]
  });

const router = createRouter();

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = `无界写作 - ${to.meta.title}`;
  }

  // 检查是否需要登录
  const token = localStorage.getItem('token');

  // 需要登录的页面但没有 token，跳转到登录页
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    // 如果已经在登录页，直接通过
    if (to.path === '/login') {
      next();
      return;
    }
    // 不在登录页，跳转到登录页
    next({ path: '/login', replace: true });
    return;
  }
  
  // 已登录访问登录页，重定向到首页
  if (to.path === '/login' && token) {
    next({ path: '/', replace: true });
    return;
  }
  
  next();
});

export default router;
